import React from "react";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import BlockIcon from '@material-ui/icons/Block'

export function ChatBlock({currentChat}) {
  return (
    <div
      style={{
        display: "flex",
        backgroundColor: "#fdecea",
        fontWeight: "500",
        color: "#611a15",
        width: "100%",
        height: "100%",
        position: "relative",
        textAlign: "center",
      }}
    >
      <div style={{ margin: "auto" }}>
        <BlockIcon
          style={{ marginRight: 10, fontSize: 18, color: "#f44336" }}
        />
        <EventLabel2
          name={currentChat == "NONE" ? "NoChatSelected" : ( currentChat == "NONE2" ? "GroupChatDisabled": "YouBeenBlockedByAdmin")}
          groupName="DigitalMeeting.Chat"
        />
      </div>
    </div>
  );
}
